import React from 'react';

const PortfolioContext = React.createContext();

export default PortfolioContext;